module.exports = __webpack_public_path__ + "img/new-profile.76d3598b.svg";